import React, { useRef, useState } from 'react';
import { LearnMoreCard } from './LearnMoreCard';
import { LearnMoreModal } from './LearnMoreModal';
import { AdditionalContent } from '@/types/additionalContent';

interface LearnMoreProps {
  content: AdditionalContent[];
}

export const LearnMore: React.FC<LearnMoreProps> = ({ content }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [selectedContent, setSelectedContent] = useState<AdditionalContent | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const comingSoon = false;

  // Sort content by order field (ascending)
  const sortedContent = [...content].sort((a, b) => (a.order || 0) - (b.order || 0));

  const handleCardClick = (item: AdditionalContent) => {
    setSelectedContent(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedContent(null);
  };

  const handleScroll = (direction: 'prev' | 'next') => {
    if (scrollContainerRef.current) {
      const cardWidth = 282; // Card width
      const gap = 18; // Gap between cards
      const scrollAmount = cardWidth + gap;

      const newScrollLeft = direction === 'next'
        ? scrollContainerRef.current.scrollLeft + scrollAmount
        : scrollContainerRef.current.scrollLeft - scrollAmount;

      scrollContainerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }
  };

  return (

    <section className="flex flex-col items-stretch justify-center p-2 max-md:max-w-full" data-tour="learn-more-section">
      <div className="flex w-full flex-col overflow-hidden items-stretch justify-center p-2.5 max-md:max-w-full bg-white to-gray-50 rounded-[10px]">
        <div className="w-full max-md:max-w-full">
          {/* Scroll Buttons (header only when scroll enabled) */}
          {!comingSoon && (
            <div className="flex w-full items-center gap-[40px_100px] justify-end flex-wrap max-md:max-w-full">
              <div className="self-stretch flex items-center gap-[5px] justify-center my-auto">
                <button
                  onClick={() => handleScroll('prev')}
                  className="w-6 h-6 rounded-[50px] hover:scale-110 transition-transform cursor-pointer"
                  aria-label="Scroll left"
                >
                  <img
                    src="https://api.builder.io/api/v1/image/assets/e7c2d913b4d14422810bbda8f72e0c16/307209d5da576e82bb5b8881666d4eefcfb7f2bd?placeholderIfAbsent=true"
                    alt="Previous"
                    className="w-6 h-6"
                  />
                </button>

                <button
                  onClick={() => handleScroll('next')}
                  className="w-6 h-6 rounded-[50px] hover:scale-110 transition-transform cursor-pointer"
                  aria-label="Scroll right"
                >
                  <img
                    src="https://api.builder.io/api/v1/image/assets/e7c2d913b4d14422810bbda8f72e0c16/61276fd5f267839703471eeeef61bf86b9a056aa?placeholderIfAbsent=true"
                    alt="Next"
                    className="w-full h-full pointer-events-none"
                  />
                </button>
              </div>
            </div>
          )}
          { /* Scrollable Cards Container */ }
          <div className="relative">
            <div
              ref={scrollContainerRef}
              className="w-full mt-2 max-md:max-w-full overflow-x-auto overflow-y-hidden scrollbar-hide"
              style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
              <div className="flex items-center gap-[18px] justify-start flex-nowrap">
                {sortedContent.map((item, index) => (
                  <LearnMoreCard
                    key={item.id || index}
                    image={item.imageUrl}
                    onClick={comingSoon || !item.videoUrl ? undefined : () => handleCardClick(item)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <LearnMoreModal
        isOpen={isModalOpen}
        content={selectedContent}
        onClose={handleCloseModal}
      />
    </section>
  );
};
